"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isScheduler = isScheduler;

function isScheduler(value) {
  return value && typeof value.schedule === 'function';
}